// src/components/Layout.js
import { Box, useTheme } from "@mui/material";
import React from "react";

const Layout = ({ children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.mode === "dark" ? "#2c2b2b" : "background.default",
        color: "text.primary",
        p: 0,
        m: 0,
      }}
    >
      {children}
    </Box>
  );
};

export default Layout;